import { actionTypes, initialState } from "./appoinment.constant";

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ON_LOADING_APPOINMENT: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }
    case actionTypes.ON_SUCCESS_APPOINMENT: {
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }
    case actionTypes.ON_DATA_APPOINMENT: {
      return {
        ...state,
        isLoading: false,
        appoinments: [...action.payload.data],
        count: action.payload.count,
        total: action.payload.total,
        pagination: action.payload.pagination,
      };
    }
    case actionTypes.ON_QUERY_DATA_APPOINMENT: {
      return {
        ...state,
        isLoading: false,
        appoinments: action.payload.data,
        count: action.payload.count,
        total: action.payload.total,
        pagination: action.payload.pagination,
      };
    }
    case actionTypes.ON_LOADING_DELETE_DATA_APPOINMENT: {
      return {
        ...state,
        appoinmentDeleteLoading: true,
      };
    }
    case actionTypes.ON_SUCCESS_DELETE_DATA_APPOINMENT: {
      return {
        ...state,
        appoinmentDeleteLoading: false,
      };
    }

    case actionTypes.ON_ERROR_APPOINMENT: {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    }
    case actionTypes.ON_DEFAULT_DATA_APPOINMENT: {
      return {
        ...state,
        isLoading: false,
        error: null,
        total: 0,
        count: 0,
      };
    }
    default:
      return { ...state };
  }
};
